import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'

const initialState = {
  tag: {
    month: moment().month() + 1,
    year: moment().format('YYYY'),
    selectedMonthYear: new Date(),
  },
  loading: false,
  activeTab: 'inventory', // 'inventory' or 'delivery'
}

export const projectDashboardListSlice = createAppSlice({
  name: 'projectDashboardList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
    setActiveTab: create.reducer((state, { payload }) => {
      state.activeTab = payload
    }),
  }),
})

export const { setFetchOption, setLoading, setActiveTab } =
  projectDashboardListSlice.actions

export default projectDashboardListSlice.reducer
